import { createApp, watch, ref } from 'vue';
import { createPinia } from 'pinia';
import 'element-plus/es/components/loading/style/css';
import { ElLoading } from 'element-plus';
import App from './App.vue';
import './assets/main.css';
import '@/assets/iconfont/iconfont.css';
import 'element-plus/es/components/message/style/css';


import installIcon from '@/plugins/installIcon'; // icon 注册
import { router } from '@/plugins/installRouter'; // 路由注册
import { useTrackState } from "@/stores/trackState";

const app = createApp(App);
// app.config.globalProperties.$showLoading = ref(false);
// app.config.globalProperties.$ElLoading = ElLoading.service({
//     text: '核心加载中...'
// });

const pinia = createPinia();


app.use(pinia);
app.use(router);
app.use(installIcon);

//confirmation modal to ensure players do not lose progress
const trackStore = useTrackState(); // Access track state

const isEditingRoute = (path: string) => ['/editor', '/mobileeditor'].includes(path);

// Handle browser refresh/close
window.addEventListener('beforeunload', (event) => {
    if (trackStore.trackList.length > 0 && isEditingRoute(router.currentRoute.value.path)) {
      event.preventDefault();
      // Note: Some browsers require the returnValue property to be set for the dialog to show
      return ''; // Modern browsers ignore this value but still show the dialog
    }
  });

// Handle route changes
router.beforeEach((to, from, next) => {
  if (
    trackStore.trackList.length > 0 &&
    isEditingRoute(from.path) &&
    !isEditingRoute(to.path)
  ) {
    const confirmed = window.confirm('Are you sure you want to exit the editor? All progress will be lost.');
    if (!confirmed) {
      return next(false); // Prevent navigation
    }
  }
  next();
});

app.mount('#vite-app');
